import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import ABApiService from '@/services/ABApiService';
import CartService from '@/services/CartService';
import LoggingService from '@/services/LoggingService';
import LoginService from '@/services/LoginService';
import Vue from 'vue';
import Axios from 'axios';
import Vuelidate from 'vuelidate';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import '../assets/styles/rin-swal.less';
import AnnouncementBarService from '@/services/AnnouncementBarService';
import CurrencyService from '@/services/CurrencyService';
import { onApplicationError, onFetchError, onValidationError } from '@/errors/errors';
import ApiService from '../services/ApiService';
import ApplicationError from '../errors/application-error';
import ValidationError from '../errors/validation-error';
import FetchError from '../errors/fetch-error';
import ErrorHandlerHelper from './ErrorHandlerHelper';
import ProductService from '../services/ProductService';
import FApiService from '../services/FApiService';
import FrontpageService from '../services/FrontpageService';
import WpApiService from '../services/WpApiService';
import PartnerApplicationService from '../services/PartnerApplicationService';
import SingleIncentiveService from '../services/SingleIncentiveService';

Vue.use(Vuelidate);
Vue.use(VueSweetalert2, { buttonsStyling: false });

Vue.config.errorHandler = (err: Error): void => {
  if(err instanceof ApplicationError) {
    onApplicationError(err);
  } else if(err instanceof ValidationError) {
    onValidationError(err);
  } else if(err instanceof FetchError) {
    onFetchError(err);
  } else {
    ErrorHandlerHelper.handleError(err, { logToConsole: true });
  }
};

const abApiService = new ABApiService(Axios);
const announcementBarService = new AnnouncementBarService();
const apiService = new ApiService(Axios);
const cartService = new CartService(apiService);
const currencyService = new CurrencyService(apiService);
const fApiService = new FApiService(Axios);
const productService = new ProductService(apiService);
const wpApiService = new WpApiService(Axios);
const frontpageService = new FrontpageService(apiService, fApiService, wpApiService);
const partnerApplicationService = new PartnerApplicationService(apiService);
const loginService = new LoginService(apiService);
const loggingService = new LoggingService();
const singleIncentiveService = new SingleIncentiveService(apiService);

Vue.prototype.$abApiService = abApiService;
Vue.prototype.$announcementBarService = announcementBarService;
Vue.prototype.$apiService = apiService;
Vue.prototype.$cartService = cartService;
Vue.prototype.$currencyService = currencyService;
Vue.prototype.$fApiService = fApiService;
Vue.prototype.$frontpageService = frontpageService;
Vue.prototype.$loggingService = loggingService;
Vue.prototype.$loginService = loginService;
Vue.prototype.$partnerApplicationService = partnerApplicationService;
Vue.prototype.$productService = productService;
Vue.prototype.$wpApiService = wpApiService;
Vue.prototype.$singleIncentiveService = singleIncentiveService;

export default Vue;
